"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTML = exports.HTMLDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var unwrap_single_tag_1 = require("../../utils/unwrap-single-tag");
exports.HTMLDefaultProps = {
  allowedTags: sanitize_html_1.default.defaults.allowedTags.concat(["h2"]),
  allowedAttributes: sanitize_html_1.default.defaults.allowedAttributes,
  allowedIframeHostnames: sanitize_html_1.default.defaults.allowedIframeHostnames,
  inline: true,
  text: ''
};
// -------- Components -------->
var HTML = function (props) {
  var className = props.className,
    inline = props.inline,
    text = props.text,
    allowedTags = props.allowedTags,
    allowedAttributes = props.allowedAttributes,
    allowedIframeHostnames = props.allowedIframeHostnames,
    unwrap = props.unwrap;
  var sanitized = (0, sanitize_html_1.default)(text, {
    allowedTags: allowedTags,
    allowedAttributes: allowedAttributes,
    allowedIframeHostnames: allowedIframeHostnames
  });
  var html = unwrap ? (0, unwrap_single_tag_1.unwrapSingleTag)(sanitized, unwrap) : sanitized;
  var Tag = inline ? 'span' : 'div';
  return React.createElement(Tag, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};
exports.HTML = HTML;
exports.HTML.defaultProps = exports.HTMLDefaultProps;